/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {CalendarMonthOutlined, Flag, PointOfSaleOutlined} from "@mui/icons-material";
import IngresoDinero from "../../../Modulo_formularios/Componentes/IngresoDinero";
import IngresoFecha from "../../../Modulo_formularios/Componentes/IngresoFecha";
import IngresoSelect from "../../../Modulo_formularios/Componentes/IngresoSelect";
import {METODOBONO} from "../../../Constantes";

const Formulario_Reserva_Abono_Individual = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={12}
                spacing={2}
            >

                <Grid container size={6}>
                    <IngresoFecha Icono={CalendarMonthOutlined} editable={false} nombre={'Fecha'} dato={'fecha'} {...props} prevenir={true} />
                </Grid>

                <Grid container size={6}>
                    <IngresoSelect Icono={Flag} nombre={'Metodo de Abono'} dato={'metodo'} {...props}
                                   opciones={METODOBONO} requerido={'Metodo Requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoDinero Icono={PointOfSaleOutlined} nombre={'Valor Abono'} dato={'valor'} {...props} />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Reserva_Abono_Individual